// src/Dashboard/pages/user/PrepaPhysique/utils/prepaPhysiqueUserUtils.js

export const DEFAULT_FILTERS = {
  search: "",
  status: "all", // all | done | todo
  programme: "",
};

export const toAbsolute = (url) => {
  if (!url) return "";

  const value = String(url).trim();

  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (!value.startsWith("/uploads")) {
    return value;
  }

  const base = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";
  return `${base}${value}`;
};

export const getExerciseImage = (exercise) => {
  return toAbsolute(exercise?.lien_photo) || "/img/no-image.jpg";
};

export const getExerciseVideo = (exercise) => {
  return String(exercise?.lien_video || "").trim();
};

export const getExerciseAssignment = (exercise) => {
  return exercise?.AdherentPrepaPhysique || exercise?.adherent_prepa_physique || {};
};

export const getExerciseDone = (exercise) => {
  const assignment = getExerciseAssignment(exercise);
  return !!assignment?.is_done;
};

export const getExerciseRepetitions = (exercise) => {
  const assignment = getExerciseAssignment(exercise);

  if (
    assignment?.repetitions === null ||
    assignment?.repetitions === undefined ||
    assignment?.repetitions === ""
  ) {
    return 0;
  }

  return Number(assignment.repetitions);
};

export const getExerciseDate = (exercise) => {
  const assignment = getExerciseAssignment(exercise);
  return assignment?.date_realisation || "";
};

export const getExerciseProgramme = (exercise) => {
  return String(exercise?.programme || "").trim();
};

export const formatDateFR = (dateValue) => {
  if (!dateValue || dateValue === "0000-00-00") return "—";

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) return "—";

  return date.toLocaleDateString("fr-FR");
};

export const isValidDateValue = (dateValue) => {
  if (!dateValue || dateValue === "0000-00-00") return false;

  const date = new Date(dateValue);

  return !Number.isNaN(date.getTime());
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const stripHtml = (html) => {
  if (!html) return "";

  if (typeof document === "undefined") {
    return String(html).replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
  }

  const div = document.createElement("div");
  div.innerHTML = html;

  return (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
};

export const truncate = (text, max = 140) => {
  const value = String(text || "").trim();

  if (value.length <= max) return value;

  return `${value.slice(0, max)}…`;
};